// extracted by mini-css-extract-plugin
export default {"headerBar":"CreateObservationRss_headerBar__TKu2L"};